import React from "react";
import NumberedHeading from "../components/NumberedHeading";
import { useRecoilState } from "recoil";
import { detailedResultState } from "../../../utils/recoil";
import { getNodeAssetUrl } from "../../../config";
import { useTranslation } from "react-i18next";

const Figures = () => {
  const [data] = useRecoilState(detailedResultState);
  const { t } = useTranslation("result");
  return (
    <div className="bg-gradient-to-b from-[#F1F7FF]/20 via-[#F1F7FF] to-[#F1F7FF]/20 py-20 px-[10rem] md-max:px-[1rem] md-max:py-0 md-max:gap-6 flex flex-col gap-12">
      <NumberedHeading number={"3"} title={t("figure.title")} />
      <div className="flex md-max:flex-col gap-7 justify-between">
        {data?.figures?.celebrities?.slice(0,5)?.map((celeb, index) => (
          <div key={index} className="flex flex-col gap-1 items-center">
            <img
              src={getNodeAssetUrl(celeb?.image, "/celeb.png")}
              alt="celebrity"
              className="w-[200px] h-[200px] object-cover"
            />
            <p className="text-lg font-semibold text-center">{celeb?.name}</p>
            <p className="text-center text-sm font-normal leading-[24px]">
              {celeb?.description}{" "}
            </p>
          </div>
        ))}
      </div>
      <p className="text-xl md-max:text-[16px] font-normal leading-[32px]">
       {data?.figures?.description}
      </p>
    </div>
  );
};

export default Figures;
